import React from "react";
import { CircularProgress } from "@material-ui/core";

import styles from "../JobShiftPreStart/JobShiftPreStartView.module.css";
import useJobShiftReadinessViewModel from "./useJobShiftReadinessViewModel";
import JobShiftReadinessDocument from "./JobShiftReadinessDocument";

const BackIcon = () => (
  <svg height="16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" aria-hidden="true">
    <path fill="currentColor" d="M73.4 297.4C60.9 309.9 60.9 330.2 73.4 342.7L233.4 502.7C245.9 515.2 266.2 515.2 278.7 502.7C291.2 490.2 291.2 469.9 278.7 457.4L173.3 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L173.3 288L278.7 182.6C291.2 170.1 291.2 149.8 278.7 137.3C266.2 124.8 245.9 124.8 233.4 137.3L73.4 297.3z" />
  </svg>
);

export default function JobShiftReadinessOverlay({ open, context, onClose }) {
  const { loading, loaded, readiness, sections, onReadinessChange } = useJobShiftReadinessViewModel({ open, context });

  if (!open) {
    return null;
  }

  return (
    <div className={styles.PreviewOverlay}>
      <div className={styles.PreviewModal}>
        {loading || !loaded ? (
          <div className={styles.viewPreview}>
            <div className={styles.PreviewPlatformBar}>
              <div>
                <button className={styles.PreviewPlatformButton} onClick={onClose} type="button">
                  <BackIcon />
                  <span>Back</span>
                </button>
              </div>
              <div className="text-muted">Rescue Readiness</div>
            </div>
            <div className="d-flex align-items-center justify-content-center" style={{ height: "calc(100% - 54px)" }}>
              <CircularProgress size={30} />
            </div>
          </div>
        ) : (
          <JobShiftReadinessDocument
            sections={sections}
            readiness={readiness}
            context={context}
            onClose={onClose}
            onReadinessChange={onReadinessChange}
          />
        )}
      </div>
    </div>
  );
}
